import React from "react";
import { Route, Routes } from "react-router-dom";

import { pageNotFound } from "lib/errorHandler";
import { Page } from "lib/page";

import { AddResultsPage } from "./addResults";
import { CreatePatientPage } from "./createPatient";
import { IssueDevice, WithdrawDevice } from "./device";
import { UpdatePatientPage } from "./editPatient";
import { EditResultsPage } from "./editResults";
import { PatientPage } from "./patient";
import { PatientsPage } from "./patients";
import { SearchPage } from "./search";

export const PatientsIndex: React.FC = () => {
  return (
    <Routes>
      {pageNotFound}
      <Route index element={<Page element={<PatientsPage />} />} />
      <Route path="search" element={<Page element={<SearchPage />} />} />
      <Route path="add/*" element={<Page element={<CreatePatientPage />} />} />
      <Route path=":id/*">
        {pageNotFound}
        <Route index element={<Page element={<PatientPage />} />} />
        <Route path="result/new/*" element={<Page element={<AddResultsPage />} />} />
        <Route path="result/:resultId/*" element={<Page element={<EditResultsPage />} />} />
        <Route path="edit/*" element={<Page element={<UpdatePatientPage />} />} />
        <Route path="issue-device/*" element={<Page element={<IssueDevice />} />} />
        <Route path="withdraw-device/*" element={<Page element={<WithdrawDevice />} />} />
      </Route>
    </Routes>
  );
};
